var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "edit_carrier_block", staticClass: "row no-gutters carrier-block" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-xl-4 mb-3 mb-xl-0 pl-0 pr-0 pr-xl-3" },
        [
          _c(
            "fieldset",
            { staticClass: "border border-primary pt-2 pb-4 px-4 rounded" },
            [
              _c(
                "legend",
                {
                  staticClass:
                    "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                },
                [_vm._v("Carrier Details")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "editLinks",
                  staticClass: "text-right edit-links",
                  staticStyle: { display: "block" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "JavaScript:void(0);" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggleSave("edit")
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-edit",
                        attrs: { title: "Edit Agency" }
                      }),
                      _vm._v(" Edit Details")
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters edit-details" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("input-text", { attrs: { fieldData: _vm.carrierName } }),
                    _vm._v(" "),
                    _c("input-text", { attrs: { fieldData: _vm.carrierTag } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-subtext pr-2 cartag" }, [
                      _c("div", {
                        staticClass: "form-text smaller-font-content",
                        domProps: { innerHTML: _vm._s(_vm.carrierTag.sub_text) }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "radio-field" },
                      [
                        _c("input-radio-button", {
                          attrs: { fieldData: _vm.carrierStatus }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "detailsbtn",
                  staticClass: "text-right mt-3 details-button",
                  staticStyle: { display: "none" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        type: "button",
                        id: "add-user-cancel",
                        tabindex: "1"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleSave("cancel")
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success ml-3",
                      attrs: { type: "button", tabindex: "1" },
                      on: {
                        click: function($event) {
                          return _vm.saveCarrierInfo("details")
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-xl-8 pl-0 pr-0" },
        [
          this.$store.getters.getAddStatus
            ? _c(
                "fieldset",
                { staticClass: "border border-primary px-4 py-3 rounded" },
                [
                  _c(
                    "legend",
                    {
                      staticClass:
                        "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                    },
                    [_vm._v("Carrier Integration Set up")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "new_integration", staticClass: "row no-gutters" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-5" },
                        [
                          _c("input-product-type", {
                            attrs: { insuranceType: _vm.insuranceType }
                          }),
                          _vm._v(" "),
                          _c("input-select", {
                            attrs: { fieldData: _vm.integrationType }
                          }),
                          _vm._v(" "),
                          _vm.showRateCallBox
                            ? _c("input-select", {
                                attrs: { fieldData: _vm.ratecallType }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showDefautlIDBox
                            ? _c("input-text", {
                                attrs: { fieldData: _vm.defaultCarrierId }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "radio-field" },
                            [
                              _c("input-radio-button", {
                                attrs: { fieldData: _vm.programStatus }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-7 pl-4" }, [
                        _vm.errorMsg
                          ? _c(
                              "span",
                              { staticClass: "invalid-feedback d-block" },
                              [_vm._v("Select atleast one state.")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "state-heading" }, [
                          _vm._v("State(s)")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row no-gutters" },
                          [
                            _vm._l(_vm.carrierState.values, function(
                              car,
                              ckey
                            ) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: ckey,
                                    staticClass:
                                      "col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-input-checkbox form-group"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-checkbox smaller-font-content"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.checked,
                                                  expression: "checked"
                                                }
                                              ],
                                              ref: car.stateName,
                                              refInFor: true,
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                type: "checkbox",
                                                id: car.stateName,
                                                name: car.stateName
                                              },
                                              domProps: {
                                                value: car.stateCd,
                                                checked: Array.isArray(
                                                  _vm.checked
                                                )
                                                  ? _vm._i(
                                                      _vm.checked,
                                                      car.stateCd
                                                    ) > -1
                                                  : _vm.checked
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a = _vm.checked,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = car.stateCd,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.checked = $$a.concat(
                                                            [$$v]
                                                          ))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.checked = $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                      }
                                                    } else {
                                                      _vm.checked = $$c
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.check(
                                                      car.stateCd
                                                    )
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "custom-control-label",
                                                attrs: { for: car.stateName }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(car.stateName) +
                                                    " (" +
                                                    _vm._s(car.stateCd) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.showDefautlIDBox
                                              ? _c("input", {
                                                  ref: car.stateCd + "_ext",
                                                  refInFor: true,
                                                  class: {
                                                    "edit-st form-control": true
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    disabled: "",
                                                    name: car.stateCd + "_ext",
                                                    id: car.stateCd + "_ext",
                                                    "aria-describedby":
                                                      car.stateName +
                                                      "_describedby"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row no-gutters justify-content-end" },
                    [
                      _c("div", { staticClass: "col-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              type: "button",
                              id: "edit-agency-cancel",
                              tabindex: "1"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toggleSave("cancelAddInt")
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success ml-3",
                            attrs: { type: "button", tabindex: "1" },
                            on: { click: _vm.saveInt }
                          },
                          [_vm._v("Save Integration")]
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.allproducts, function(product, pkey) {
            return [
              _c(
                "div",
                {
                  key: pkey + "_pro",
                  staticClass: "row no-gutters edit-integration"
                },
                [
                  _vm._l(product.integrationPlatforms, function(
                    integrationPlatform
                  ) {
                    return [
                      _c(
                        "fieldset",
                        {
                          key: integrationPlatform.integrationId,
                          ref:
                            "edit_int_details" +
                            product.productId +
                            "_" +
                            integrationPlatform.integrationId,
                          refInFor: true,
                          staticClass:
                            "w-100 border border-primary pt-2 px-4 pb-3 rounded",
                          staticStyle: { display: "none" }
                        },
                        [
                          _c(
                            "legend",
                            {
                              staticClass:
                                "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                            },
                            [_vm._v("Integration")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 px-0" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-4" },
                                [
                                  _c("img", {
                                    staticClass: "edit-platform-logo mb-2",
                                    attrs: {
                                      src:
                                        integrationPlatform.integrationLogoURL,
                                      alt: integrationPlatform.integrationName
                                    }
                                  }),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "productName",
                                      class:
                                        "product-icon-" + product.productName
                                    },
                                    [_vm._v(_vm._s(product.productName))]
                                  ),
                                  _vm._v(" "),
                                  integrationPlatform.integrationId == 1
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mt-3",
                                          attrs: {
                                            id: "def_section",
                                            "label-for": "def_ext_id"
                                          }
                                        },
                                        [
                                          _c("div", [
                                            _c("label", [
                                              _vm._v(
                                                "Default External Carrier ID"
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "star" },
                                                [_vm._v("*")]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true}"
                                              }
                                            ],
                                            attrs: {
                                              id: "def_ext_id",
                                              name: "def_ext_id",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                integrationPlatform.defaultExternalCarrierId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  integrationPlatform,
                                                  "defaultExternalCarrierId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "integrationPlatform.defaultExternalCarrierId"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-invalid-feedback",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.errors.has(
                                                    "def_ext_id"
                                                  ),
                                                  expression:
                                                    "errors.has('def_ext_id')"
                                                }
                                              ],
                                              attrs: { "force-show": true }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "def_ext_id"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group mt-2 radio-field"
                                    },
                                    [
                                      _vm._m(0, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "input-group field-input-radio"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn-group btn-group-toggle",
                                              attrs: {
                                                "data-toggle": "buttons"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-light",
                                                  class: {
                                                    active: JSON.parse(
                                                      integrationPlatform.integrationStatus
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          integrationPlatform.integrationStatus,
                                                        expression:
                                                          "integrationPlatform.integrationStatus"
                                                      }
                                                    ],
                                                    attrs: {
                                                      name:
                                                        "instatus_" +
                                                        product.productId +
                                                        "_" +
                                                        integrationPlatform.integrationId,
                                                      id:
                                                        "instatus_true_" +
                                                        product.productId +
                                                        "_" +
                                                        integrationPlatform.integrationId,
                                                      type: "radio",
                                                      value: "true"
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        integrationPlatform.integrationStatus,
                                                        "true"
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          integrationPlatform,
                                                          "integrationStatus",
                                                          "true"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "cursorBox",
                                                      attrs: {
                                                        for:
                                                          "instatus_true_" +
                                                          product.productId +
                                                          "_" +
                                                          integrationPlatform.integrationId
                                                      }
                                                    },
                                                    [_vm._v("ACTIVE")]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-light",
                                                  class: {
                                                    active: !JSON.parse(
                                                      integrationPlatform.integrationStatus
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          integrationPlatform.integrationStatus,
                                                        expression:
                                                          "integrationPlatform.integrationStatus"
                                                      }
                                                    ],
                                                    attrs: {
                                                      name:
                                                        "instatus_" +
                                                        product.productId +
                                                        "_" +
                                                        integrationPlatform.integrationId,
                                                      id:
                                                        "instatus_false_" +
                                                        product.productId +
                                                        "_" +
                                                        integrationPlatform.integrationId,
                                                      type: "radio",
                                                      value: "false"
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        integrationPlatform.integrationStatus,
                                                        "false"
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          integrationPlatform,
                                                          "integrationStatus",
                                                          "false"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "cursorBox",
                                                      attrs: {
                                                        for:
                                                          "instatus_false_" +
                                                          product.productId +
                                                          "_" +
                                                          integrationPlatform.integrationId
                                                      }
                                                    },
                                                    [_vm._v("INACTIVE")]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-8" }, [
                                _c("span", { staticClass: "state-heading" }, [
                                  _vm._v("State(s)")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row no-gutters" },
                                  [
                                    _vm._l(
                                      integrationPlatform.integrationAppointedStates,
                                      function(platformState, key) {
                                        return _c("carrier-platform-state", {
                                          key: key,
                                          attrs: {
                                            platformState: platformState,
                                            integrationId:
                                              integrationPlatform.integrationId,
                                            productId: product.productId,
                                            integrationPlatform: integrationPlatform
                                          }
                                        })
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 text-right mt-3" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary",
                                            attrs: {
                                              type: "button",
                                              id: "edit-agency-cancel",
                                              tabindex: "1"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.toggleEditInt(
                                                  "cancel",
                                                  product.productId,
                                                  integrationPlatform.integrationId
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Cancel")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-success ml-3",
                                            attrs: {
                                              type: "button",
                                              tabindex: "1"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveCarrierInfo(
                                                  "editint"
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Save Integration")]
                                        )
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.allproducts, function(product, pkey) {
            return [
              _c(
                "div",
                { key: pkey, staticClass: "row no-gutters" },
                [
                  _vm._l(product.integrationPlatforms, function(
                    integrationPlatform,
                    ikey
                  ) {
                    return [
                      _c(
                        "fieldset",
                        {
                          key: ikey,
                          ref:
                            "int_details" +
                            product.productId +
                            "_" +
                            integrationPlatform.integrationId,
                          refInFor: true,
                          staticClass:
                            "w-100 border border-primary pt-2 px-4 pb-3 rounded",
                          staticStyle: { display: "block" }
                        },
                        [
                          _c(
                            "legend",
                            {
                              staticClass:
                                "w-auto px-2 font-weight-bold smaller-font-content text-primary"
                            },
                            [_vm._v("Integration")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 px-0" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-3" }, [
                                _c("img", {
                                  staticClass: "platform-logo",
                                  attrs: {
                                    src: integrationPlatform.integrationLogoURL,
                                    alt: integrationPlatform.integrationName
                                  }
                                }),
                                _vm._v(" "),
                                _c("br"),
                                _c(
                                  "span",
                                  {
                                    staticClass: "productName",
                                    class: "product-icon-" + product.productName
                                  },
                                  [_vm._v(_vm._s(product.productName))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group" }, [
                                  _vm._m(1, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group field-input-radio"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn-group btn-group-toggle locked",
                                          attrs: { "data-toggle": "buttons" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-outline-light",
                                              class: {
                                                active: JSON.parse(
                                                  integrationPlatform.integrationStatus
                                                )
                                              }
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  name:
                                                    "instatuss_" +
                                                    product.productId +
                                                    "_" +
                                                    integrationPlatform.integrationId,
                                                  id:
                                                    "instatuss_true_" +
                                                    product.productId +
                                                    "_" +
                                                    integrationPlatform.integrationId,
                                                  type: "radio",
                                                  value: "true",
                                                  disabled: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "cursorBox",
                                                  attrs: {
                                                    for:
                                                      "instatuss_true_" +
                                                      product.productId +
                                                      "_" +
                                                      integrationPlatform.integrationId
                                                  }
                                                },
                                                [_vm._v("ACTIVE")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "btn btn-outline-light",
                                              class: {
                                                active: !JSON.parse(
                                                  integrationPlatform.integrationStatus
                                                )
                                              }
                                            },
                                            [
                                              _c("input", {
                                                attrs: {
                                                  name:
                                                    "instatuss_" +
                                                    product.productId +
                                                    "_" +
                                                    integrationPlatform.integrationId,
                                                  id:
                                                    "instatuss_false_" +
                                                    product.productId +
                                                    "_" +
                                                    integrationPlatform.integrationId,
                                                  type: "radio",
                                                  value: "false",
                                                  disabled: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "cursorBox",
                                                  attrs: {
                                                    for:
                                                      "instatuss_false_" +
                                                      product.productId +
                                                      "_" +
                                                      integrationPlatform.integrationId
                                                  }
                                                },
                                                [_vm._v("INACTIVE")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-9" }, [
                                _c("div", { staticClass: "row no-gutters" }, [
                                  _c("div", { staticClass: "col-9 def-text" }, [
                                    _c("div", {}, [
                                      _vm._v("Default External Carrier ID")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "my-2 font-weight-normal"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            integrationPlatform.defaultExternalCarrierId
                                          )
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col text-right edit-links"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "JavaScript:void(0);"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.toggleEditInt(
                                                "edit",
                                                product.productId,
                                                integrationPlatform.integrationId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-edit",
                                            attrs: { title: "Edit Agency" }
                                          }),
                                          _vm._v(" Edit Integration")
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row no-gutters" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 state-heading mb-1"
                                    },
                                    [_vm._v("State(s)")]
                                  ),
                                  _vm._v(" "),
                                  _vm.integratedStatess(
                                    integrationPlatform.integrationAppointedStates
                                  )
                                    ? _c(
                                        "div",
                                        [
                                          _vm._l(
                                            _vm.integratedStatess(
                                              integrationPlatform.integrationAppointedStates
                                            ),
                                            function(platformState, key) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    key: key,
                                                    staticClass: "state-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        platformState.stateName
                                                      ) +
                                                        " (" +
                                                        _vm._s(
                                                          platformState.stateCd
                                                        ) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.showmore(
                                            integrationPlatform.integrationAppointedStates
                                          )
                                            ? _c(
                                                "span",
                                                { staticClass: "state-label" },
                                                [_vm._v("...")]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _c("div", [_vm._v("NA")])
                                ])
                              ])
                            ])
                          ])
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", [
        _vm._v("Integration Status"),
        _c("span", { staticClass: "required-red" }, [_vm._v("*")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", [
        _vm._v("Integration Status"),
        _c("span", { staticClass: "required-red" }, [_vm._v("*")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eac082ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eac082ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/carriers/stateIntegration/StateIntegration.vue
// module id = null
// module chunks = 